import { AttachmentFileType, CloudFile } from 'owa-attachment-file-types';
import { FileProviderViewState, getFileProviders } from 'owa-fileprovider-store';
import { FileSuggestion } from 'owa-search-service';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { trace } from 'owa-trace';

export default function createCloudFileFromFileSuggestion(suggestion: FileSuggestion) {
    const url = suggestion.FileUrl;
    const name = suggestion.FileName;
    const providerId = extractOneDriveProFileProviderId(getFileProviders());

    // Creating a singular cloud file object to pass to insertLinks
    const cloudFile: CloudFile = {
        fileType: AttachmentFileType.Cloud,
        name: name,
        size: 0,
        providerId: providerId,
        providerType: AttachmentDataProviderType.OneDrivePro,
        location: url,
        providerEndpointUrl: '',
        isFolder: false,
        fileId: '',
        fileParentId: '',
        thumbnailUrl: '',
        previewUrl: '',
        type: '',
    };
    return cloudFile;
}

function extractOneDriveProFileProviderId(providers: FileProviderViewState[]): string {
    for (let i = 0; i < providers.length; i++) {
        if (providers[i].type == AttachmentDataProviderType.OneDrivePro) {
            return providers[i].model.Id!;
        }
    }

    trace.warn(
        'createCloudFileFromAttachmentData: Could not get OneDrive Pro provider ID. Attachment will not upload.'
    );
    return '';
}
